import { AnomalAction, AnomalSel, AnomalType } from "@/features/anomalies";
import { AlertCard } from "@/components/AlertCard";
import Loader from "@/components/Loader";

import React, { useEffect, useState } from "react";
import { Col, Row, Typography } from "antd";
import { Update } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";

import ModalDetail from "./ModalDetail";
import { infoMapper } from "./constants";
import styles from "./styles.less";

export default () => {
  const dispatch = useDispatch();
  const anomal = useSelector(AnomalSel.anomalData);
  const [visible, setVisible] = useState(false);
  const [severity, setSeverity] = useState("");

  useEffect(() => {
    dispatch(AnomalAction.fetchAnomalDataAsync.request());
  }, []);

  if (useSelector(AnomalSel.dataFetch) === "REQUEST") return <Loader />;

  return (
    <Row gutter={30} className={styles.anomaly}>
      <ModalDetail severity={severity} visible={visible} setVisible={setVisible} />
      {Object.keys(anomal)
        .reverse()
        .map((k: string) => (
          <Col xs={24} md={12} lg={12} xl={6} key={k}>
            <div
              onClick={() => {
                setVisible(true);
                setSeverity(k);
              }}
            >
              <AlertCard
                smallIcon={<Update />}
                icon={infoMapper[k].icon}
                title={infoMapper[k].title}
                color={infoMapper[k].color}
                description={infoMapper[k].description}
              >
                <Typography.Title level={2}>
                  {Object.keys(anomal[k as keyof AnomalType.AnomalData]).length}
                  <small style={{ fontSize: "50%", color: "#999" }}>cases</small>
                </Typography.Title>
              </AlertCard>
            </div>
          </Col>
        ))}
    </Row>
  );
};
